import { Mods, mods } from '@approvalmax/theme';
import { Table } from '@approvalmax/ui/src/components';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { UserRow } from '../../UserList.types';

export const HideableCell = styled(Table.Cell<UserRow>)<StyledMods<Mods<'hide'>>>`
    ${mods.hide.true`
        opacity: 0;
    `}
`;
